import css from './styles/universities-marquee.module.css';

const UniversitiesMarquee: React.FC = () => {
  return (
    <div className={css.container}>
      <div className={css.marqueeWrapper}>
        <div className={css.marqueeContentTitleMobile}>
          Trusted by top universities
        </div>

        <div className={css.marquee}>
          <img
            src={require('images/UBC.png')}
            alt="University of British Columbia logo"
          />
          <img
            src={require('images/UB.png')}
            alt="University of Bradford logo"
          />
          <img src={require('images/Duke.png')} alt="Duke University logo" />
          <img
            src={require('images/UWF.png')}
            alt="University of West Florida logo"
          />
          <img
            src={require('images/MSU.png')}
            alt="Michigan State University logo"
          />
        </div>
      </div>
    </div>
  );
};

export default UniversitiesMarquee;
